import React from 'react'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import { Map } from 'immutable'
import { removeModal } from './modalActions'
import RedirectModal from './RedirectModal'
import NotificationModal from './NotificationModal'
import UrlCopyModal from './UrlCopyModal'
import { logWarning } from '../../sentry'
import { selectModalsQueueHead } from '../../selectors/modalSelectors'

export const NOTIFICATION_MODAL = 'notificationModal'
export const REDIRECT_MODAL = 'redirectModal'
export const LOGIN_REQUIRED_MODAL = 'loginRequiredModal'
export const URL_COPY_MODAL = 'urlCopyModal'

const Modals = () => {
  const dispatch = useDispatch()

  const { activeModal, activeModalData } = useSelector((state) => {
    let activeModal = selectModalsQueueHead(state)
    let activeModalData = null

    // Map some data based on the active modal type
    if (activeModal) {
      switch (activeModal.get('id')) {
        case REDIRECT_MODAL: {
          const itemId = activeModal.get('data').get('itemId')
          const item = state.items.items.get(itemId)
          if (item) {
            const link = state.items.items.get(itemId).get('link')
            const title = state.items.items.get(itemId).get('title')
            activeModalData = Map({
              itemLink: link,
              itemTitle: title,
            })
          } else {
            logWarning('Invalid item id: ' + itemId)
            activeModal = null
          }
          break
        }
        case NOTIFICATION_MODAL:
          activeModalData = Map({
            message: activeModal.get('data').get('message'),
            title: activeModal.get('data').get('title'),
          })
          break

        default:
          activeModalData = activeModal.get('data')
      }
    }

    return {
      activeModal,
      activeModalData,
    }
  }, shallowEqual)

  if (!activeModal) return null

  const handleModalClose = (modalId) => {
    dispatch(removeModal(modalId))
  }

  switch (activeModal.get('id')) {
    case REDIRECT_MODAL:
      return (
        <RedirectModal
          onClose={ handleModalClose }
          itemLink={ activeModalData.get('itemLink') }
          itemTitle={ activeModalData.get('itemTitle') }
        />
      )

    case NOTIFICATION_MODAL:
      return (
        <NotificationModal
          onClose={ handleModalClose }
          message={ activeModalData.get('message') }
          title={ activeModalData.get('title') }
        />
      )

    case URL_COPY_MODAL:
      return (
        <UrlCopyModal
          onClose={ handleModalClose }
          url={ activeModalData.get('url') }
          title={ activeModalData.get('title') }
        />
      )

    default:
      return null
  }
}

export default Modals
